$(document).ready(function() {

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    cache: false,
    beforeSend: function() {}, // override broken global one
    dataType: 'json',
    success: function(cart){

      try {
        if (cart.item_count > 0)
        {
          let data = { updates: {} };
          for (let i = 0; i < cart.items.length; i++) {

            // Priority fulfillment
            if (cart.items[i].handle == 'priority-fulfillment')
            {
                data.updates[cart.items[i].id] = 0;                
            }

            // Remove pvc-coating items without _itemhash
            if (cart.items[i].handle === 'pvc-coating' && !cart.items[i].properties?._itemhash)
            {
                data.updates[cart.items[i].id] = 0;
            }

            // Orphan products
            if (cart.items[i].hasOwnProperty("properties") &&
                cart.items[i].properties.hasOwnProperty("_unicubeitem") &&
                cart.items[i].properties._unicubeitem=='true')
            {
              
              let lookforhash = cart.items[i].properties._itemhash;
              let shouldremove = true;
              for (let j = 0; j < cart.items.length; j++) {
                if (cart.items[j].hasOwnProperty("properties") &&
                    cart.items[j].properties.hasOwnProperty("_unicubeitem") == false &&
                    cart.items[j].properties._itemhash==lookforhash)
                {
                  shouldremove = false;
                  break;
                }
              }
              
              if (shouldremove)
              {
                data.updates[cart.items[i].id] = 0;
              }
            }
          }

          // free gifts
          let tiers = {};
          
          for (let i = 0; i < cart.items.length; i++) {

            if (cart.items[i].product_description.indexOf("#freegift#") > 0 )
            {
              let freegiftvalue = Number(cart.items[i].product_description.split("#freegift#")[1]);
              if ((cart.total_price/Shopify.currency.rate) < freegiftvalue || tiers.hasOwnValue(freegiftvalue))
              {
                data.updates[cart.items[i].id] = 0;
              }
              else if (cart.items[i].quantity > 1)
              {
                data.updates[cart.items[i].id] = 0;
              }
              else
              {
                tiers[freegiftvalue] = 1;
              }
            }
          }
          
          if (Object.keys(data.updates).length > 0)
          {
            $.ajax({
              type: 'POST',
              url: "/cart/update.js",
              data: data,
              dataType: 'json',

              complete: function(data) {
                location.reload(); 
              }

            });
          }
        }
        
      } catch(err)
      {
        console.log(err);
      }
    }
  });

});
